import React from 'react';
import { PaymentMethod } from '../utils/constants.ts';

export const ConfirmOrderModalBody = (paymentMethod: PaymentMethod) => {
  const now = new Date();
  const hour = now.getHours();
  const day = now.getDay(); // 0 = domingo, 6 = sábado
  const isToday = hour < 8;

  let deliveryLabel: string;
  if (isToday) {
    deliveryLabel = 'HOY';
  } else if (day === 6) {
    // Sábado después de las 8 → entrega el lunes
    deliveryLabel = 'LUNES';
  } else {
    deliveryLabel = 'MAÑANA';
  }

  return (
    <>
      <span>
        Estás a punto de confirmar tu pedido que será entregado{' '}
        {isToday ? 'durante el día de ' : 'el día de '}
      </span>
      <strong>{deliveryLabel}</strong>
      {paymentMethod === PaymentMethod.TRANSFER ||
      paymentMethod === PaymentMethod.MERCADOPAGO ? (
        <>
          <br />
          <br />
          <span>
            Por favor enviar el comprobante de pago por WhatsApp para que se
            despache su pedido.
          </span>
        </>
      ) : null}
    </>
  );
};
